export const pricingConfig: any = {
  currencyCode: 'USD',
  visibleCells: 4,
};
